/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import React, { useEffect, useState } from 'react';
import './InterceptMessageModal.scss';

import { AAMBeaconButton, AAMBeaconModal } from 'components/shared/Beacon';
import { isBrkInterceptMsgEnabled } from 'services/FeatureFlags';
import { AEM } from 'services/Externals';
import {
  CONTENT_TYPES,
  getContentFromCMS
} from 'services/ContentManagement/CMSUtils';

const InterceptMessageModal = ({ openBrokerageAuthTab, setHasResponsebrkIntercept }) => {
  const [prospectTerms, setProspectTerms] = useState('');

  useEffect(() => {
    if (isBrkInterceptMsgEnabled()) {
      getContentFromCMS(
        AEM.FRAGMENTS.brokerageInterceptMessage,
        'item',
        CONTENT_TYPES.LIST,
        (root) => {
          return {
            html: root['body']?.['html'],
            title: root['title'],
            primaryActionLabel: root['primaryActionLabel'],
            secondaryActionLabel: root['secondaryActionLabel']
          };
        }
      )
        .then((response) => {
          if (response !== null && response['html'] && response['title'] && response['primaryActionLabel'] && response['secondaryActionLabel']) {
            setProspectTerms(response);
          } else {
            setHasResponsebrkIntercept(false);
          }
        }).catch(() => {
          setHasResponsebrkIntercept(false);
      })
    }
  }, []);

  const handleModalClose = () => {
    const modal = document.getElementById('account-selection-modal') ?? null;
    if (modal !== null) {
      modal.close();
    }
  };
  return isBrkInterceptMsgEnabled() ? (
    <>
      <AAMBeaconModal scale="jumbo" id="account-selection-modal">
        <div className="brokerage-Intercept-title">
          <p className="b-typography-serif--headline--200 b-font-weight-bold ">
            {prospectTerms['title']}
          </p>
        </div>
        <p
          className="consent-intercept-copy a"
          dangerouslySetInnerHTML={{ __html: prospectTerms['html'] }}
        />

        <div slot="action-zone" className="action-zone-space-between">
          <AAMBeaconButton
            variant="tertiary"
            onBeaconEventClick={() => {
              openBrokerageAuthTab();
              handleModalClose();
            }}
            scale="normal">
            {prospectTerms['secondaryActionLabel']}
          </AAMBeaconButton>
          <AAMBeaconButton
            onBeaconEventClick={() => handleModalClose()}
            variant="primary"
            scale="normal">
            {prospectTerms['primaryActionLabel']}
          </AAMBeaconButton>
        </div>
      </AAMBeaconModal>
    </>
  ) : (
    <></>
  );
};

export default InterceptMessageModal;
